<template>
  <v-row v-if="isSuccessConnectingLogBox === true">
    <v-col cols="12" sm="6" md="4" lg="3">
      <v-card hover v-on:click="if (!isSendingCalibrationCommand) isCalibrationWithParentBox = !isCalibrationWithParentBox;">
        <v-card-item>
          <template v-slot:prepend>
            <v-icon color="success" class="mt-n1">
              mdi-router-wireless
            </v-icon>
          </template>
          <v-card-title class="text-subtitle-1 font-weight-bold">
            親機
          </v-card-title>

          <template v-slot:append>
            <v-checkbox density="compact" hide-details color="primary" class="mt-n1"
              v-model="isCalibrationWithParentBox" :disabled="isSendingCalibrationCommand"></v-checkbox>
          </template>
        </v-card-item>

        <v-card-text class="pb-0">
          <div class="px-2 pb-2" style="height: 110px;">

            <div class="h-100 d-flex align-center" v-if="isSendingCalibrationCommand && isCalibrationWithParentBox">

              <div class="flex-fill" v-if="parentBoxCalibratedCO2Value == null">
                <p class="text-center text-subtitle-1 mb-3">
                  {{ (wasSentParentCalibrationCommand) ? '大気校正中&nbsp;...' : '子機の校正完了を待っています' }}
                </p>
                <v-progress-linear striped height="10" color="grey-darken-2" model-value="100"></v-progress-linear>
              </div>

              <v-row v-else>
                <v-col cols="3" class="d-flex align-center justify-center">
                  <v-icon size="50" color="success">
                    mdi-check-circle
                  </v-icon>
                </v-col>
                <v-col cols="9" class="d-flex flex-column align-center justify-center">
                  <p class="align-self-start">
                    校正が完了しました
                  </p>
                  <p class="mt-2 me-8 text-subtitle-1 font-weight-bold">
                    {{ parentBoxCalibratedCO2Value }}&nbsp;ppm
                  </p>
                </v-col>
              </v-row>

            </div>

          </div>
        </v-card-text>
      </v-card>
    </v-col>

    <v-col cols="12" sm="6" md="4" lg="3" v-for="device of devices" v-bind:key="device.id">
      <v-card hover v-on:click="if (!device.isWaitingVersionResponse && !isSendingCalibrationCommand) device.isSelected = !device.isSelected;">

        <v-overlay contained persistent :transition="false" class="align-center justify-center" v-model="device.isWaitingVersionResponse">
          <v-progress-circular size="110" indeterminate v-if="isSendingGetVersionCommand">
            <template v-slot:default>
              通信中&nbsp;...
            </template>
          </v-progress-circular>

          <p v-else>
            通信できませんでした
          </p>
        </v-overlay>

        <v-card-item>
          <template v-slot:prepend>
            <v-icon :color="device.isWaitingVersionResponse ? 'grey-darken-2' : 'success'" class="mt-n1">
              mdi-router-wireless
            </v-icon>
          </template>
          <v-card-title class="text-subtitle-1 font-weight-bold">
            {{ device.name }}
          </v-card-title>

          <template v-slot:append>
            <v-checkbox density="compact" hide-details color="primary" class="mt-n1"
              v-model="device.isSelected" :disabled="isSendingCalibrationCommand"></v-checkbox>
          </template>
        </v-card-item>

        <v-card-text class="pb-0">
          <div class="px-2 pb-2" style="height: 110px;">

            <div class="h-100 d-flex align-center" v-if="device.isSelected && isSendingCalibrationCommand">

              <div class="flex-fill" v-if="device.isSuccessCalibration == null">
                <p class="text-center text-subtitle-1 mb-3">
                  大気校正中&nbsp;...
                </p>
                <v-progress-linear striped color="secondary" height="10"
                  :model-value="device.calibrationProgress"></v-progress-linear>
              </div>

              <v-row v-else>
                <v-col cols="3" class="d-flex align-center justify-center">
                  <v-icon size="50" :color="(device.isSuccessCalibration) ? 'success' : 'error'">
                    {{ (device.isSuccessCalibration) ? 'mdi-check-circle' : 'mdi-close-circle' }}
                  </v-icon>
                </v-col>
                <v-col cols="9" class="d-flex flex-column align-center justify-center">
                  <p class="align-self-start">
                    {{ (device.isSuccessCalibration) ? '校正が完了しました' : '校正に失敗しました' }}
                  </p>
                  <p class="mt-2 me-8 text-subtitle-1 font-weight-bold" v-if="device.isSuccessCalibration">
                    {{ device.co2 }}&nbsp;ppm
                  </p>
                </v-col>
                <v-col cols="12">
                  <p class="text-center text-caption">
                    {{ (device.isSuccessCalibration) ?
                      '電源を入れ直すとデータ登録を再開します' : '電源を入れ直して再度実施してください' }}
                  </p>
                </v-col>
              </v-row>

            </div>

          </div>

          <v-divider color="black"></v-divider>

          <v-expand-transition>
            <div class="pt-2 px-1" v-if="device.isShowDetail">
              <p class="mt-1">
                ソフトウェア&nbsp;Ver.&nbsp;{{ device.firmwareVersion }}
              </p>
              <p class="mt-1">
                通信モジュール&nbsp;Ver.&nbsp;{{ device.LoRaFirmwareVersion }}
              </p>
            </div>
          </v-expand-transition>
        </v-card-text>

        <v-card-actions class="py-0 px-2 justify-end">
          <v-btn :icon="(device.isShowDetail ? 'mdi-chevron-up' : 'mdi-chevron-down')" size="small"
            v-on:click.stop="device.isShowDetail = !device.isShowDetail;"></v-btn>
        </v-card-actions>

      </v-card>
    </v-col>

    <v-col cols="12" v-if="!isSendingGetVersionCommand">
      <v-card elevation="0">
        <v-card-actions class="py-2 px-3">
          <v-row no-gutters>
            <v-col :cols="$vuetify.display.mobile ? 12 : 7" class="d-flex justify-end align-center">
              <p v-bind:class="{ 'pa-3': $vuetify.display.mobile }">
                親機のセンサ校正：{{ isCalibrationWithParentBox ? 'する' : 'しない' }}
              </p>
            </v-col>
            <v-col :cols="$vuetify.display.mobile ? 12 : 2" class="d-flex justify-end align-center">
              <p v-bind:class="{ 'pa-3': $vuetify.display.mobile }">
                選択した子機：{{ selectedDeviceCount }}台
              </p>
            </v-col>
            <v-col :cols="$vuetify.display.mobile ? 12 : 3" class="py-1 d-flex justify-end">
              <v-btn variant="flat" color="primary" class="px-3"
                v-on:click="sendCalibrationCommand" :loading="isSendingCalibrationCommand"
                :disabled="isSendingCalibrationCommand || selectedDeviceCount === 0">
                CO2センサの大気校正を開始
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>

  <v-card max-width="580" class="mx-auto py-1 px-2" v-if="!isCheckedNotes">
    <v-card-item>
      <v-card-title>
        ご注意ください
      </v-card-title>
    </v-card-item>
    <v-card-text>
      <p>子機のCO2センサの大気校正を行うには、準備が必要です</p>
      <ul class="py-4 px-6">
        <li>外気が十分にあたる場所に置いてください</li>
        <li>電源制御機を介さずに、直接電源を接続してください</li>
        <li>親機ログBOX、子機の電源を入れてから5分以上待ってから実施してください</li>
      </ul>
    </v-card-text>
    <v-card-actions class="py-3 justify-end">
      <v-btn variant="flat" color="primary" class="px-4" v-on:click="startCommunication">
        上記を確認しました
      </v-btn>
    </v-card-actions>
  </v-card>

  <div class="text-center" v-if="isCheckedNotes && isSuccessConnectingLogBox == null">
    <v-progress-circular size="230" indeterminate class="mt-9">
      <template v-slot:default>
        接続しています&nbsp;...
      </template>
    </v-progress-circular>
  </div>

  <div v-if="isSuccessConnectingLogBox === false">
    <v-alert variant="tonal" type="error" max-width="580" class="mx-auto mt-5">
      通信に失敗しました。親機ログBOXが稼働していることを確認して、再度お試しください
    </v-alert>
  </div>
</template>

<script>
import { ref, computed, onMounted, onBeforeUnmount } from 'vue';

import mqtt from 'mqtt/dist/mqtt.min';

import config from '@/config.js';

export default {
  name: 'AuthenticationView',
  setup() {

    const isCheckedNotes = ref(false);

    const isSuccessConnectingLogBox = ref(null);

    const isSendingGetVersionCommand = ref(true);

    const isSendingCalibrationCommand = ref(false);

    const isCalibrationWithParentBox = ref(false);
    const wasSentParentCalibrationCommand = ref(false);
    const parentBoxCalibratedCO2Value = ref(null);

    const devices = ref([]);

    const selectedDeviceCount = computed(() => {
      return devices.value.reduce((sum, device) => {
        return sum + (device.isSelected ? 1 : 0)
      }, 0)
    });

    const userID = window.sessionStorage.getItem('userID');
    const boxID = config.users[userID].boxes['親'].boxID.toString();

    const CommandHeaderTemplate = '<!' + config.users[userID].boxes['親'].deviceID + ':K{TARGET_ID_LIST}>';

    var mqttClient;

    var connectionTimeoutID;

    var calibrationStartTime;

    onMounted(() => {

      Object.keys(config.users[userID].boxes).forEach((key) => {

        if (key === '親') {
          return;
        }

        devices.value.push({
          id: config.users[userID].boxes[key].deviceID,
          name: '子機' + key,

          isWaitingVersionResponse: true,
          isShowDetail: false,

          isSelected: false,
          calibrationProgress: 0.5,
          isSuccessCalibration: null
        });

      });

    });

    onBeforeUnmount(() => {
      if (mqttClient != null) {
        mqttClient.end();
      }
    });

    const startCommunication = () => {

      isCheckedNotes.value = true;

      mqttClient = mqtt.connect(config.MQTT_BROKER_URL, {
        reconnectPeriod: 0,
        clientId: userID,
        username: userID,
        password: window.sessionStorage.getItem('token')
      });

      mqttClient.on('connect', () => {
        mqttClient.subscribe('lora-proxy/' + boxID + '/pong', (error) => {
          if (error) return;

          connectionTimeoutID = setTimeout(() => {
            mqttClient.end();
            isSuccessConnectingLogBox.value = false;
          }, 10 * 1000);

          mqttClient.publish('lora-proxy/' + boxID + '/ping', '');
        });
      });

      mqttClient.on('message', (topic, message) => {

        if (topic.includes('pong')) {

          mqttClient.subscribe('lora-proxy/' + boxID + '/response', (error) => {
            if (error) return;

            clearTimeout(connectionTimeoutID);
            mqttClient.unsubscribe('lora-proxy/' + boxID + '/pong');

            setTimeout(() => {
              isSendingGetVersionCommand.value = false;
            }, 60 * 1000);


            const targetList = [];
            Object.keys(config.users[userID].boxes).forEach((key) => {
              if (key === '親') return;
              targetList.push(config.users[userID].boxes[key].deviceID);
            });

            const commandHeader = CommandHeaderTemplate.replace('{TARGET_ID_LIST}', targetList.join(','));
            const getVersionCommand = commandHeader + '{"CO":"GV"}'

            mqttClient.publish('lora-proxy/' + boxID + '/command', getVersionCommand);


            isSuccessConnectingLogBox.value = true;
          });

          return;

        }


        const rawResponse = message.toString();

        if (topic.startsWith('logbox')) {

          if (topic.includes('calibration')) {

            if (JSON.parse(rawResponse).result) {

              mqttClient.subscribe('logbox/' + boxID + '/result/box/environment', (error) => {
                if (error) return;

                setTimeout(() => {
                  mqttClient.publish('logbox/' + boxID + '/operation/box/environment', '');
                }, 10 * 1000);
              });

            }

          } else {

            const environmentValues = JSON.parse(rawResponse).result;
            if ('SCD30_co2' in environmentValues) {
              parentBoxCalibratedCO2Value.value = Math.round(environmentValues.SCD30_co2);
            }

          }

          return;
        }


        const fromID = rawResponse.substring(2, 7);
        const responseBody = JSON.parse(rawResponse.substring(8, rawResponse.lastIndexOf('[')));

        const respondedDevice = devices.value.find((device) => device.id === fromID);

        switch (responseBody.co) {

          case 'gv':

            respondedDevice.firmwareVersion = responseBody.p0;
            respondedDevice.LoRaFirmwareVersion = responseBody.p1;

            respondedDevice.isWaitingVersionResponse = false;


            var isAllDeviceResponded = true;

            devices.value.forEach((device) => {
              if (device.isWaitingVersionResponse) {
                isAllDeviceResponded = false;
              }
            });

            if (isAllDeviceResponded) {
              isSendingGetVersionCommand.value = false;
            }

            break;


          case 'ca':

            if (isSendingCalibrationCommand.value) {
              switch (responseBody.p0) {

                case 2: // 計測中
                  respondedDevice.calibrationProgress = ((responseBody.p1 / 15) * 100) + 0.5;
                  break;

                case 3: // 処理完了

                  // 以前に送信した校正コマンドに対する応答のためスルー
                  if (Date.now() < (calibrationStartTime + (15 * 10 * 1000))) {
                    break;
                  }


                  if (responseBody.p1 === 1) {

                    respondedDevice.isSuccessCalibration = true;
                    respondedDevice.co2 = responseBody.p2;


                    if (isCalibrationWithParentBox.value && !wasSentParentCalibrationCommand.value) {

                      var isAllChildsCalibrated = true;

                      devices.value.forEach((device) => {
                        if (device.isSelected) {
                          if (device.isSuccessCalibration == null || device.isSuccessCalibration === false) {
                            isAllChildsCalibrated = false;
                          }
                        }
                      });

                      if (isAllChildsCalibrated) {

                        wasSentParentCalibrationCommand.value = true;

                        mqttClient.subscribe('logbox/' + boxID + '/result/scd30/calibration', (error) => {
                          if (error) return;

                          mqttClient.publish(
                            'logbox/' + boxID + '/operation/scd30/calibration',
                            '{"co2":400}'
                          );
                        });

                      }

                    }


                  } else {
                    respondedDevice.isSuccessCalibration = false;
                  }

                  break;

              }
            }

            break;

        }

      });

    };

    const sendCalibrationCommand = () => {

      isSendingCalibrationCommand.value = true;

      const targetList = [];
      devices.value.forEach((device) => {
        if (device.isSelected) {
          targetList.push(device.id);
        }
      });

      const commandHeader = CommandHeaderTemplate.replace('{TARGET_ID_LIST}', targetList.join(','));
      const calibrationCommand = commandHeader + '{"CO":"CA","P0":3,"P1":15,"P2":400}'

      mqttClient.publish('lora-proxy/' + boxID + '/command', calibrationCommand);

      calibrationStartTime = Date.now();

    };

    return {
      isCheckedNotes,

      isSuccessConnectingLogBox,

      isSendingGetVersionCommand,

      isSendingCalibrationCommand,

      isCalibrationWithParentBox,
      wasSentParentCalibrationCommand,
      parentBoxCalibratedCO2Value,

      devices,

      selectedDeviceCount,

      startCommunication,

      sendCalibrationCommand
    }

  }
}
</script>
